/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'guide': {
    width: 218.164,
    height: 200,
    viewBox: '0 0 1117 1024',
    data: '<defs/><path pid="0" d="M53.865 558.08l289.92 121.6 560-492.16-491.52 530.56 371.84 140.8c8.96 3.2 19.2-1.28 22.4-10.24V848l260.48-816.64-1014.4 494.72c-8.96 4.48-12.16 14.72-8.32 23.68 2.56 3.84 5.76 7.04 9.6 8.32zm357.76 434.56l144.64-155.52-144.64-58.88v214.4z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/guide.js